module.exports = __webpack_public_path__ + "static/signature.1.0.0-white-46d6b5267c61b237f5c866ac13347877.png";